<template>
  <div class="pb-5">
    <nav-bar/>
    <!-- <sidebar-toggle-button/> -->
    <div class="filter-button-group">
      <div class="d-flex justify-content-center align-items-center">
        <toggle-button-group
          :buttons="filterOptions" 
          :activeButton="selectedFilter" 
          :handleClick="handleFilterButtonClick" 
        />
     </div>
    </div>
    <!-- SIDEBAR -->
    <!-- <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
          <li class="nav-item" id="current">
            <a class="nav-link navbar-text" href="#/TransferPending">
              {{$t('TransferPending.sidebar.pending')}}
            </a>
            <span v-if="transfers.length > 0" class="pull-right badge badge-default">{{ transfers.length }}</span>
          </li>
          <li class="nav-item">
            <a class="nav-link navbar-text" href="#/TransferCurrent">
              {{$t('TransferPending.sidebar.completed')}}
            </a>
          </li>
      </ul>
    </div> -->

    <table-element
      :isShowFilter="true"
      :title="$t('TransferPending.title')"
      :fields="fieldsObj"
      :arrOfElement="transfers"
      :sortSpacing="0"
      :isShowSelectAll="false"
      class="card mx-2 mt-2"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
        <p v-if="isLengthBelowZero" class="red-text">{{$t('TransferPending.no_orders_found')}}</p>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="order['.key']"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'transfered': order.status === 'Transférée'
          }">
          <td class="nowrap">{{order['.key'] || '-'}}</td>
          <td class="nowrap">{{order.vin || '-'}}</td>
          <td class="nowrap">{{getDate(order.creationDate) || '-'}}</td>
          <td class="nowrap"><p class="table-fix-width">{{$realName(order, 'transmitter') || '-'}}</p></td>
          <td class="nowrap"><p class="table-fix-width">{{$realName(order, 'receiver') || '-'}}</p></td>
          <td class="nowrap">{{order.nameTransfered || '-'}}</td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <transition-group name="fade">
          <div class="card my-3 mx-2" v-for="transfer in content.results" :key="transfer['.key']" >
              <div class="card-header m-2">
                <h4>{{transfer['.key']}}</h4>
                <p><i class="fa fa-calendar" />{{getDate(transfer.creationDate) || '-'}}</p>
              </div>
              <div class="m-2">
              <p v-if="transfer.nameTransfered"><i class="fa fa-building" />{{transfer.nameTransfered || '-'}}</p>
              <p v-else><i class="fa fa-building" />-</p>
              <p><i class="fa fa-car" />{{transfer.vin || '-'}}</p>
              <p><i class="fa fa-home" />{{$realName(transfer, 'transmitter') || '-'}}</p>
              <p><i class="fa fa-truck" />{{$realName(transfer, 'receiver') || '-'}}</p>
            </div>
          </div>
        </transition-group>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

  </div>
</template>

<script>
import Modal from '../module/interface-components/Modal.vue'
import regularInput from '../module/basic-components/regularInput.vue'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import Search from '../module/special-components/Other-components/Search.vue'
import {db} from '../../firebase'
// import _ from 'lodash'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'

export default {
  name: 'transferPending',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    Search,
    SidebarToggleButton,
    TableElement,
    LoadingRender,
    ToggleButtonGroup
  },

  data () {
    return {
      feedbackMessage: '',
      closedModal: true,
      fields: {
        '.key': '',
        vin: '',
        creationDate: '',
        transmitterName: '',
        receiverName: '',
        nameTransfered: ''
      },
      filterResults: [],
      transfers: [],
      paginate: ['filterResults'],
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      fieldsObj: [
       {
         text: this.$t('TransferPending.order'),
         type: '.key',
         value: ''
       },
       {
         text: this.$t('TransferPending.VIN'),
         type: 'vin',
         value: ''
       },
       {
         text: this.$t('TransferPending.date'),
         type: 'creationDate',
         value: ''
       },
       {
         text: this.$t('TransferPending.pickup'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('TransferPending.delivery'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('TransferPending.carrier'),
         type: 'nameTransfered',
         value: ''
       }
      ],
      selectedFilter: 'pending',
      filterOptions: [
        { label: this.$t('NavBar.orders'), value: 'orders', route: '/OrderCurrent' },
        { label: `${this.$t('TransferCompleted.sidebar.pending')} (0)`, value: 'pending', route: '/TransferPending' },
        { label: `${this.$t('TransferCompleted.sidebar.completed')}`, value: 'in_progress', route: '/TransferCurrent' }
      ]
    }
  },

  created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false
    this.isScreenSmall = window.innerWidth < 800

    this.$bindAsArray('transfers', db.ref('test/transporter/' + this.companyUID + '/pendingTransfer'), null, () => {})
    this.$bindAsArray('pending', db.ref('test/transporter/' + this.companyUID + '/pendingTransfer'), null, () => {
      this.filterOptions[1] = { label: `${this.$t('TransferCompleted.sidebar.pending')} ${this.pending.length}`, value: 'pending', route: '/TransferPending' }
    })

    this.isLoading = false
  },

  methods: {
    handleFilterButtonClick (buttonName) {
      this.selectedFilter = buttonName
      const selectedOption = this.filterOptions.find(option => option.value === buttonName)
      if (selectedOption && selectedOption.route) {
        this.$router.push(selectedOption.route)
      }
    },
    onItemFilterSelect (value) {
      this.selectedItem = value
      const selectedOption = this.itemFilterOptions.find(option => option.value === value)

      if (selectedOption && selectedOption.route) {
        this.$router.push(selectedOption.route)
      }
    },
    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    evaluateFiltering (attr, val) {
      this.fields[attr] = val

      var isAttrDupe = false
      if (val === '') {
        return
      }
      this.searchHistory.find((o, i) => {
        if (o.searchType === attr) {
          var storedDupeTag = this.setSearchedItemTag(attr)
          this.searchHistory[i] = {
            searchType: attr, searchText: val, historyTypeTag: storedDupeTag}
          isAttrDupe = true
          return
        }
      })
      if (!isAttrDupe) {
        this.addSearchedItem(attr, val)
      }
    },
    setSearchedItemTag (attr) {
      var storedTag
      if (attr === '.key') { storedTag = this.$t('TransferPending.order') }
      if (attr === 'vin') { storedTag = this.$t('TransferPending.VIN') }
      if (attr === 'creationDate') { storedTag = this.$t('TransferPending.date') }
      if (attr === 'transmitterName') { storedTag = this.$t('TransferPending.pickup') }
      if (attr === 'receiverName') { storedTag = this.$t('TransferPending.delivery') }
      if (attr === 'nameTransfered') { storedTag = this.$t('TransferPending.carrier') }
      return storedTag
    },
    addSearchedItem (searchedType, searchedText) {
      var storedTag = this.setSearchedItemTag(searchedType)
      this.searchHistory.push({searchType: searchedType, searchText: searchedText, historyTypeTag: storedTag})
    },
    removeSearchedItem (index, attr) {
      this.searchHistory.splice(index, 1)
      this.evaluateFiltering(attr, '')
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString()
    },

    onResize: window._.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },

    isLengthBelowZero () {
      console.log(this.transfers.length <= 0)
      return this.transfers.length <= 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
</style>
